export default {
   features() {
      return [
         {
            "no": 1,
            "category": "title",
            "feature": "General"
         },
         {
            "no": 2,
            "category": "General",
            "feature": "Included synced tablet app <br/>(to be use on tractor/self)",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 3,
            "category": "General",
            "feature": "Management program runs in browser (nothing to install)",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 4,
            "category": "General",
            "feature": "All data is automatically backed up and store in a secure cloud service",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 5,
            "category": "General",
            "feature": "Multi Language support (EN, FR, DE and more)",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 6,
            "category": "title",
            "feature": "Feeds Management"
         },
         {
            "no": 7,
            "category": "Feeds Management",
            "feature": "Add custom feed with dry material % and Value",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 8,
            "category": "Feeds Management",
            "feature": "Mark manually load feed",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 9,
            "category": "Feeds Management",
            "feature": "Manage loading tolerance allow per feed",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 19,
            "category": "title",
            "feature": "TMR Management"
         },
         {
            "no": 20,
            "category": "TMR Management",
            "feature": "Calculate TMR value and dry material from feeds data",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 21,
            "category": "TMR Management",
            "feature": "Manage TMR feeds content",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 22,
            "category": "TMR Management",
            "feature": "Manage dose weight",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 23,
            "category": "TMR Management",
            "feature": "Track TMR versions",
            "standard": true,
            "advance": true
         },
         {
            "no": 24,
            "category": "TMR Management",
            "feature": "Allow premix",
            "standard": true,
            "advance": true
         },
         {
            "no": 25,
            "category": "TMR Management",
            "feature": "TMR Builder <br />(using simplex formula based on nutritional values)",
            "advance": "Future"
         },
         {
            "no": 26,
            "category": "title",
            "feature": "Groups Management"
         },
         {
            "no": 27,
            "category": "Groups Management",
            "feature": "Manage groups with names and types",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 28,
            "category": "Groups Management",
            "feature": "Track animal count",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 29,
            "category": "Groups Management",
            "feature": "Manage TMR for the group",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 30,
            "category": "Groups Management",
            "feature": "Allow up to two different TMR per Group with daily percent for each TMR",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 31,
            "category": "Groups Management",
            "feature": "Allow flexible delivery schedule per day of the week",
            "standard": true,
            "advance": true
         },
         {
            "no": 32,
            "category": "title",
            "feature": "Wagons Management"
         },
         {
            "no": 33,
            "category": "Wagons Management",
            "feature": "Wagon Planning with simple Drag n Drop",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 34,
            "category": "Wagons Management",
            "feature": "Number of Wagons per day",
            "basic": 5,
            "standard": "Unlimited",
            "advance": "Unlimited"
         },
         {
            "no": 35,
            "category": "Wagons Management",
            "feature": "Allow different wagons for different days of the week",
            "standard": true,
            "advance": true
         },
         {
            "no": 36,
            "category": "Wagons Management",
            "feature": "Auto calculate the daily portions for each group base on: Daily portions, TMR percentage, dose weight, and headcount",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 37,
            "category": "title",
            "feature": "Tablet (android) App in tractor/self"
         },
         {
            "no": 38,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Automatically sync with planned data",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 39,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Connect to your vehicle's scale with optional bluetooth transmitter",
            "basic": "optional*",
            "standard": "optional*",
            "advance": "optional*"
         },
         {
            "no": 40,
            "category": "Tablet (android) App in tractor/self",
            "feature": "View daily plan",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 41,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Select wagon or use pre plan order",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 42,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Change loading order",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 43,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Switch to next feed loading Automatically or manually",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 44,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Track actual loading quantity",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 45,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Audio alert when feed loading nearly done"
         },
         {
            "no": 46,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Warn when loading is below or above allowed tolerances",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 47,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Unload TMR to ground option",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 48,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Change group unloading order ",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 49,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Track actual unloading quantity",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 50,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Warn when unloading outside allowed tolerances",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 51,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Audio alert when group unloading nearly done",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 52,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Change Group Appetite with Tablet app",
            "standard": true,
            "advance": true
         },
         {
            "no": 53,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Automatically sync activities to management app",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 54,
            "category": "Tablet (android) App in tractor/self",
            "feature": "Dark them to decrease blindness in pre-done work"
         },
         {
            "no": 55,
            "category": "title",
            "feature": "Reports"
         },
         {
            "no": 56,
            "category": "Reports",
            "feature": "Report Actual Production",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 57,
            "category": "Reports",
            "feature": "Report Actual Deliveries",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 58,
            "category": "Reports",
            "feature": "Report Material and Dry Material Use",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 59,
            "category": "Reports",
            "feature": "Feeds needed base on plan",
            "basic": true,
            "standard": true,
            "advance": true
         },
         {
            "no": 60,
            "category": "Reports",
            "feature": "Inventory Levels Reports",
            "advance": true
         },
         {
            "no": 61,
            "category": "Reports",
            "feature": "Transactions log",
            "advance": true
         },
         {
            "no": 62,
            "category": "title",
            "feature": "Inventory Management"
         },
         {
            "no": 63,
            "category": "Inventory Management",
            "feature": "View Feed quantity in stock",
            "advance": true
         },
         {
            "no": 64,
            "category": "Inventory Management",
            "feature": "Transaction for feed purchases",
            "advance": true
         },
         {
            "no": 65,
            "category": "Inventory Management",
            "feature": "Automatic transaction for feed use in production",
            "advance": true
         },
         {
            "no": 66,
            "category": "Inventory Management",
            "feature": "TMR level when unloading loading to/from ground",
            "advance": true
         },
         {
            "no": 67,
            "category": "Inventory Management",
            "feature": "Reset feed qty (when reaching actual 0)",
            "advance": true
         },
         {
            "no": 68,
            "category": "Inventory Management",
            "feature": "Periodic Inventory Count process",
            "advance": true
         },
         {
            "no": 69,
            "category": "Inventory Management",
            "feature": "Inventory level report",
            "advance": true
         },
         {
            "no": 70,
            "category": "Inventory Management",
            "feature": "Adjust feeds and TMR value base on actual purchase price",
            "advance": true
         },
      ]
   }
}